import axios from "axios";

import { organizationEndpoints } from "@api/Endpoints";

import { OrganizationNameResponse } from "../models/OrganizationNameResponse";

export const getOrganizationName = async (
  accessToken: string,
  language: string
): Promise<string | null> => {
  const url = organizationEndpoints.organizationName();
  const request = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Accept-Language": language
    }
  };
  try {
    const response = await axios.get<OrganizationNameResponse>(url, request);
    return response.data?.name;
  } catch {
    return null;
  }
};
